// plugins/user-lang.client.js
import { defineNuxtPlugin } from "#app";
import { useUserLang } from "~/composables/useUserLang";

export default defineNuxtPlugin(() => {
  const userLang = useUserLang();

  // on ne fait PLUS nuxtApp.provide ni config.globalProperties…
  // Nuxt va s’en charger pour nous
  return {
    provide: {
      userLang,
    },
  };
});
